import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            [
              _c(VRow, [
                _c(
                  "h2",
                  {
                    staticClass:
                      "title primary--text text--darken-1 text-no-wrap mt-0 ml-2",
                  },
                  [_vm._v(" DADOS PESSOAIS ")]
                ),
              ]),
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    {
                      staticClass: "d-flex flex-column align-center",
                      attrs: { cols: "12", md: "4" },
                    },
                    [
                      _c(VAvatar, { attrs: { size: "220px" } }, [
                        _c("img", {
                          attrs: {
                            src: _vm.imagemPreview,
                            alt: "Imagem do Perfil",
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "12", md: "8" } },
                    [
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "12" } },
                            [
                              _c(VTextField, {
                                attrs: {
                                  color: "primary",
                                  disabled: "",
                                  label: "Nome",
                                  "prepend-icon": "assignment_ind",
                                  tabindex: "1",
                                },
                                model: {
                                  value: _vm.usuario.nomeCivil,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.usuario,
                                      "nomeCivil",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "usuario.nomeCivil",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VRow,
                        { staticClass: "mt-4", attrs: { dense: "" } },
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "12", md: "8", sm: "8" } },
                            [
                              _c(
                                VCard,
                                { attrs: { flat: "" } },
                                [
                                  _c(
                                    VCardText,
                                    [
                                      _c(
                                        "h4",
                                        [
                                          _vm._v(" Utiliza nome social? "),
                                          _c(
                                            VTooltip,
                                            {
                                              attrs: {
                                                top: "",
                                                "max-width": "500",
                                              },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "activator",
                                                  fn: function ({ on }) {
                                                    return [
                                                      _c(
                                                        VIcon,
                                                        _vm._g({}, on),
                                                        [_vm._v(" help ")]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ]),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(_vm.tooltipNomeSocial)
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VRadioGroup,
                                        {
                                          attrs: { row: "" },
                                          on: { change: _vm.temNomeSocial },
                                          model: {
                                            value:
                                              _vm.perfilUpdate.temNomeSocial,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.perfilUpdate,
                                                "temNomeSocial",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "perfilUpdate.temNomeSocial",
                                          },
                                        },
                                        [
                                          _c(VRadio, {
                                            attrs: {
                                              value: true,
                                              label: "Sim",
                                            },
                                          }),
                                          _c(VRadio, {
                                            attrs: {
                                              value: false,
                                              label: "Não",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm.perfilUpdate.temNomeSocial
                                        ? _c(VTextField, {
                                            ref: "textfieldNomeSocial",
                                            attrs: {
                                              id: "textfieldNomeSocial",
                                              rules: [
                                                (v) =>
                                                  !!v ||
                                                  "Nome social obrigatório",
                                              ],
                                              autofocus: "",
                                              color: "primary",
                                              label: "Nome Social",
                                              "prepend-icon": "assignment_ind",
                                              required: "",
                                              tabindex: "1",
                                            },
                                            on: {
                                              blur: _vm.nomeSocialVazio,
                                              keyup: _vm.uppercase,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "append",
                                                  fn: function () {
                                                    return [
                                                      _vm.perfil.nomeSocial !==
                                                      _vm.perfilUpdate
                                                        .nomeSocial
                                                        ? _c(
                                                            VBtn,
                                                            {
                                                              attrs: {
                                                                text: "",
                                                                color:
                                                                  "secondary",
                                                                small: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.updatePerfil,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Salvar "
                                                              ),
                                                              _c(
                                                                VIcon,
                                                                {
                                                                  staticClass:
                                                                    "ml-1",
                                                                  attrs: {
                                                                    small: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " check "
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm.perfil.nomeSocial !==
                                                      _vm.perfilUpdate
                                                        .nomeSocial
                                                        ? _c(
                                                            VBtn,
                                                            {
                                                              attrs: {
                                                                text: "",
                                                                color:
                                                                  "warning",
                                                                small: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.perfilUpdate.nomeSocial =
                                                                      _vm.perfil.nomeSocial
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Desfazer "
                                                              ),
                                                              _c(
                                                                VIcon,
                                                                {
                                                                  staticClass:
                                                                    "ml-1",
                                                                  attrs: {
                                                                    small: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " undo "
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              454703974
                                            ),
                                            model: {
                                              value:
                                                _vm.perfilUpdate.nomeSocial,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.perfilUpdate,
                                                  "nomeSocial",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "perfilUpdate.nomeSocial",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VRow,
                        { staticClass: "mt-4", attrs: { dense: "" } },
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "12", md: "8", sm: "8" } },
                            [
                              _c(
                                VCard,
                                { attrs: { flat: "" } },
                                [
                                  _c(
                                    VCardText,
                                    [
                                      _c("h4", [
                                        _vm._v(
                                          "Você possui alguma condição de deficiência?"
                                        ),
                                      ]),
                                      _c(
                                        VRadioGroup,
                                        {
                                          attrs: { row: "" },
                                          on: { change: _vm.temDeficiencia },
                                          model: {
                                            value: _vm.perfilUpdate.deficiente,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.perfilUpdate,
                                                "deficiente",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "perfilUpdate.deficiente",
                                          },
                                        },
                                        [
                                          _c(VRadio, {
                                            attrs: {
                                              value: true,
                                              label: "Sim",
                                            },
                                          }),
                                          _c(VRadio, {
                                            attrs: {
                                              value: false,
                                              label: "Não",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm.perfilUpdate.deficiente
                                        ? _c(VAutocomplete, {
                                            attrs: {
                                              items: _vm.deficiencias,
                                              rules: [
                                                () =>
                                                  _vm.perfilUpdate.deficiencias
                                                    .length > 0 ||
                                                  `Informe pelo menos uma condição`,
                                              ],
                                              "search-input":
                                                _vm.deficienciaSearch,
                                              autofocus: "",
                                              chips: "",
                                              color: "primary",
                                              "deletable-chips": "",
                                              "item-text": "nome",
                                              label: "Qual condição?",
                                              placeholder:
                                                "Digite para pesquisar...",
                                              multiple: "",
                                              "prepend-icon": "accessible",
                                              required: "",
                                              "return-object": "",
                                            },
                                            on: {
                                              "update:searchInput": function (
                                                $event
                                              ) {
                                                _vm.deficienciaSearch = $event
                                              },
                                              "update:search-input": function (
                                                $event
                                              ) {
                                                _vm.deficienciaSearch = $event
                                              },
                                              change: function ($event) {
                                                _vm.updatePerfil()
                                                _vm.deficienciaSearch = ""
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "selection",
                                                  fn: function (data) {
                                                    return [
                                                      _c(
                                                        VChip,
                                                        {
                                                          staticClass:
                                                            "chip--select-multi",
                                                          attrs: {
                                                            "input-value":
                                                              data.selected,
                                                            close: "",
                                                            color: "secondary",
                                                            search: "",
                                                            small: "",
                                                            "text-color":
                                                              "white",
                                                          },
                                                          on: {
                                                            "click:close":
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.removeDeficiencia(
                                                                  data.item
                                                                )
                                                              },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                data.item.nome
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              3761568305
                                            ),
                                            model: {
                                              value:
                                                _vm.perfilUpdate.deficiencias,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.perfilUpdate,
                                                  "deficiencias",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "perfilUpdate.deficiencias",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.perfilUpdate.deficiente &&
              _vm.perfilUpdate.deficiencias.length > 0
                ? _c(
                    VRow,
                    [
                      _c(VTextarea, {
                        attrs: {
                          "auto-grow": "",
                          label:
                            "Tendo em vista a sua condição, como seria um ambiente de trabalho adaptado às suas necessidades?",
                          name: "input-4-1",
                          "prepend-icon": "settings_accessibility",
                          rows: "2",
                        },
                        on: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            $event.preventDefault()
                            return _vm.updatePerfil.apply(null, arguments)
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "append",
                              fn: function () {
                                return [
                                  _vm.perfil.observacoesDeficiencias !==
                                  _vm.perfilUpdate.observacoesDeficiencias
                                    ? _c(
                                        VBtn,
                                        {
                                          attrs: {
                                            text: "",
                                            color: "secondary",
                                            small: "",
                                          },
                                          on: { click: _vm.updatePerfil },
                                        },
                                        [
                                          _vm._v(" Salvar "),
                                          _c(
                                            VIcon,
                                            {
                                              staticClass: "ml-1",
                                              attrs: { small: "" },
                                            },
                                            [_vm._v(" check ")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.perfil.observacoesDeficiencias !==
                                  _vm.perfilUpdate.observacoesDeficiencias
                                    ? _c(
                                        VBtn,
                                        {
                                          attrs: {
                                            text: "",
                                            color: "warning",
                                            small: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.perfilUpdate.observacoesDeficiencias =
                                                _vm.perfil.observacoesDeficiencias
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(" Desfazer "),
                                          _c(
                                            VIcon,
                                            {
                                              staticClass: "ml-1",
                                              attrs: { small: "" },
                                            },
                                            [_vm._v(" undo ")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1759812812
                        ),
                        model: {
                          value: _vm.perfilUpdate.observacoesDeficiencias,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.perfilUpdate,
                              "observacoesDeficiencias",
                              $$v
                            )
                          },
                          expression: "perfilUpdate.observacoesDeficiencias",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(VRow, [
                _c(
                  "h2",
                  {
                    staticClass:
                      "title primary--text text--darken-1 text-no-wrap mt-4 ml-2",
                  },
                  [_vm._v(" DADOS PROFISSIONAIS ")]
                ),
              ]),
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12", lg: "6", md: "6" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          color: "primary",
                          disabled: "",
                          label: "N° SIAPE",
                          "prepend-icon": "pin",
                        },
                        model: {
                          value: _vm.usuario.siape,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.usuario,
                              "siape",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "usuario.siape",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "12", lg: "6", md: "6" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          color: "primary",
                          disabled: "",
                          label: "E-mail",
                          "prepend-icon": "alternate_email",
                        },
                        model: {
                          value: _vm.usuario.email,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.usuario,
                              "email",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "usuario.email",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "12", lg: "6", md: "6" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          color: "primary",
                          disabled: "",
                          label: "Cargo",
                          "prepend-icon": "engineering",
                        },
                        model: {
                          value: _vm.usuario.cargo,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.usuario,
                              "cargo",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "usuario.cargo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "12", lg: "6", md: "6" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          color: "primary",
                          disabled: "",
                          label: "Unidade de Exercício",
                          "prepend-icon": "account_balance",
                        },
                        model: {
                          value: _vm.unidade.nome,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.unidade,
                              "nome",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "unidade.nome",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.unidadePai
                    ? _c(
                        VCol,
                        { attrs: { cols: "12", lg: "6", md: "6" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              color: "primary",
                              disabled: "",
                              label: "Unidade Superior",
                              "prepend-icon": "account_balance",
                            },
                            model: {
                              value: _vm.unidadePai.nome,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.unidadePai,
                                  "nome",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "unidadePai.nome",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    VCol,
                    { attrs: { cols: "12", lg: "6", md: "6" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          color: "primary",
                          disabled: "",
                          label: "Função",
                          "prepend-icon": "badge",
                        },
                        model: {
                          value: _vm.funcao,
                          callback: function ($$v) {
                            _vm.funcao =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "funcao",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "12", lg: "4", md: "6" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          color: "primary",
                          disabled: "",
                          label: "Contato",
                          "prepend-icon": "phone",
                        },
                        model: {
                          value: _vm.usuario.contato,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.usuario,
                              "contato",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "usuario.contato",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }